<p class="rating" [class.is-sent]="sent" aria-live="polite">
  <ng-container *ngIf="!sent; else thanks">
    <span>Something not right with the videos?</span>
    <button class="rating__open" type="button" (click)="open()">Tell us</button>
  </ng-container>
  <ng-template #thanks>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 8.94753L5.2 13.1475L15 3.34753" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <span>Thanks for the feedback.</span>
  </ng-template>
</p>
